module.exports = __webpack_public_path__ + "static/logo-dpc-italia-09b6148bae4c9779867d352504aa89ed.svg";